/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { Autocomplete, Box, Chip, InputAdornment, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
// components
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from '../../../components/Iconify';
import InputStyle from '../../../components/InputStyle';
import useLocales from '../../../hooks/useLocales';
import { setPostSearch } from '../../../redux/slices/blog/blog.post';
import { getTags, setTagSearch } from '../../../redux/slices/blog/blog.tag';

// ----------------------------------------------------------------------
export default function BlogPostTableToolbar() {
  const { translate } = useLocales();
  const dispatch = useDispatch();

  const { search } = useSelector((state) => state.blogPost);
  const { tags, search: searchTag, isLoading } = useSelector((state) => state.blogTag);

  const [sortBy, setSortBy] = useState("0");

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getTags());
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchTag]);

  const handleFilterTags = (_, value) => {
    dispatch(setTagSearch({ ...searchTag, page: 0, value }));
  };

  const onFilterName = (value) => {
    dispatch(setPostSearch({ ...search, page: 0, value, }));
  };

  const onChangeTags = (tags) => {
    const tagIds = tags?.map((t) => t.id).toString();
    dispatch(setPostSearch({ ...search, page: 0, tags, filterBys: { ...search.filterBys, tagIds } }));
  };

  const handleChangeSort = (event) => {
    let value = event.target.value;

    let orders = [{ order: "desc", property: 'createdAt' }];

    if (value === "0") orders = [{ order: "desc", property: 'createdAt' }];
    else if (value === "1") orders = [{ order: "asc", property: 'createdAt' }];
    else orders = [{ order: "desc", property: 'likeNo' }];

    dispatch(setPostSearch({ ...search, page: 0, orders }));
    setSortBy(value);
  };

  return (
    <Stack spacing={2} direction={{ xs: 'column', md: 'row' }} sx={{ my: 3 }}>
      <InputStyle
        sx={{ minWidth: { md: 250 } }}
        value={search.value || ''}
        onChange={(event) => onFilterName(event.target.value)}
        placeholder={translate('label.search')}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon={'eva:search-fill'} sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          ),
          endAdornment: (search.value?.trim().length > 0 &&
            <InputAdornment position="end">
              <Iconify icon={'ic:baseline-clear'} sx={{ color: 'text.disabled', width: 20, height: 20, cursor: 'pointer' }}
                onClick={() => onFilterName("")} />
            </InputAdornment>
          )
        }}
      />
      <Autocomplete
        sx={{ minWidth: { md: 200 } }}
        multiple
        onChange={(_, newValue) => onChangeTags(newValue)}
        options={tags?.map(({ id, title, type }) => ({ id, title, type }))}
        getOptionLabel={(option) => option.title || ''}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        loading={isLoading}
        value={search?.tags || []}
        onInputChange={handleFilterTags}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip {...getTagProps({ index })} key={option.id} size="small" label={`${option.title}`} />
          ))
        }
        renderInput={(params) => (
          <TextField label={translate('hackerthon.exercise.topic')} {...params} />
        )}
      />
      <Box flexGrow={1} />
      <Box>
        <Typography variant='caption'>{translate("label.sortBy")}: </Typography>
        <Select variant='standard' value={sortBy} size='small' sx={{ fontSize: 12, fontWeight: 'bold', ml: 1, pt: 1 }} disableUnderline
          onChange={handleChangeSort} >
          <MenuItem value={"0"} sx={{ fontSize: 12 }}>{translate("label.sortByNew")}</MenuItem>
          <MenuItem value={"1"} sx={{ fontSize: 12 }} >{translate("label.sortByOld")}</MenuItem>
          <MenuItem value={"2"} sx={{ fontSize: 12 }}>{translate("label.sortByLike")}</MenuItem>
        </Select>
      </Box>
    </Stack>
  );
}
